<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.CREATE') }} {{ $t('PLANNINGS.TASKS.BLOCK.ITEM') }}
      <v-spacer></v-spacer>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      <errors class="pt-2" :errors="errorsWithoutForm" />
      <v-row>
        <v-col cols="12" xs="12" md="3">{{ $t('EMPLOYEES.ITEM') }}:</v-col>
        <v-col cols="12" xs="12" md="9">
          <span class="text-subtitle-1">{{ employeeTitle }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" md="3">{{ $t('ITEM.DATE') }}</v-col>
        <v-col cols="12" xs="12" md="9">{{
          selectedDay.date | dateFormat
        }}</v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
      <block-day-form
        v-model="task"
        :errors="errors.getAll()"
        @valid="valid = $event"
        @update-prop="clearErrorByName($event)"
      ></block-day-form>
      <v-card-actions>
        <v-btn outlined depressed color="grey" @click="cancel">
          {{ $t('BUTTON.CANCEL') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" :disabled="!valid" @click="create">
          {{ $t('BUTTON.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import { dateFormat } from '@/modules/_global/filters';
import Errors from '@/modules/_global/_components/Errors';
import BlockDayForm from '../forms/BlockDay/BlockDayForm';
import moment from 'moment';

export default {
  name: 'CreateBlockDayTask',

  filters: {
    dateFormat
  },

  components: {
    Errors,
    BlockDayForm
  },

  mixins: [errors],

  data() {
    return {
      valid: false,
      task: {}
    };
  },

  computed: {
    ...mapState('planning', ['selectedDay', 'selectedEntity']),
    employeeTitle() {
      const first = this.selectedEntity.first_name || '';
      const last = this.selectedEntity.last_name || '';

      return `${first} ${last}`.trim();
    },

    errorsWithoutForm() {
      return ['employee_id', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  mounted() {
    this.initForm();
  },

  methods: {
    ...mapActions('planning', ['storeBlockTask', 'addSnack']),

    initForm() {
      const initialDate = this.selectedDay.date;

      this.task = {
        date_from: initialDate,
        start_date: initialDate,
        end_date: moment(initialDate)
          .add(6, 'month')
          .add(-1, 'day')
          .format(moment.HTML5_FMT.DATE)
      };
    },

    cancel() {
      this.$emit('cancel');
    },

    create() {
      const task = {
        ...this.task,
        employee_id: this.selectedEntity.id
      };

      this.storeBlockTask({ task })
        .then(response => {
          const { errors, data } = response.data;

          this.$emit('created', data);

          if (errors && errors.length) {
            errors.forEach(item => {
              this.addSnack({
                color: 'orange accent-2',
                type: 'warning',
                message: item
              });
            });
          }
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
